import { inject, Injectable, Injector } from "@angular/core";

import type { BaseFilterDefinition, FilterValue } from "@filter/filter.types";
import type { JobsBillingCard, TranslateObject } from "@app/views-interfaces";
import { RoleUserFilterService, RoleFilterService } from "./roles.service";

@Injectable()
abstract class JobRoleUserFilterService extends RoleUserFilterService<JobsBillingCard> {
    protected readonly injector = inject(Injector);
}

@Injectable()
export class ContactPartnerFilterService extends JobRoleUserFilterService {
    protected roleId = "2";

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "ContactPartner",
            label: "JobsAndBilling.Contact.Partner",
        };
    }

    protected getValue(item: JobsBillingCard): FilterValue | undefined {
        return item.contactInformation.partner;
    }
}

@Injectable()
export class ContactManagerFilterService extends JobRoleUserFilterService {
    protected roleId = "1";

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "ContactManager",
            label: "JobsAndBilling.Contact.Manager",
        };
    }

    protected getValue(item: JobsBillingCard): FilterValue | undefined {
        return item.contactInformation.manager;
    }
}

@Injectable()
export class JobPartnerFilterService extends JobRoleUserFilterService {
    protected roleId = "2";

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "JobPartner",
            label: "JobsAndBilling.AssignedRoles.JobPartner",
        };
    }

    protected getValue(item: JobsBillingCard): FilterValue | undefined {
        return item.job.partner;
    }
}

@Injectable()
export class JobManagerFilterService extends JobRoleUserFilterService {
    protected roleId = "1";

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "JobManager",
            label: "JobsAndBilling.AssignedRoles.JobManager",
        };
    }

    protected getValue(item: JobsBillingCard): FilterValue | undefined {
        return item.job.manager;
    }
}

@Injectable()
abstract class JobUserFilterService extends RoleFilterService<JobsBillingCard> {
    protected readonly injector = inject(Injector);
    protected getLabel(value: string): string | undefined | null | TranslateObject {
        return this.getUsersService().getUserNameFromId()(value);
    }

    protected getAllValues(): readonly string[] {
        return Array.from(this.getUsersService().usersById()?.fromUserId.values() ?? []).map((user) => user.Id);
    }
}

@Injectable()
export class JobOwnerFilterService extends JobUserFilterService {
    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "JobOwner",
            label: "JobsAndBilling.AssignedRoles.JobOwner",
        };
    }

    protected getValue(item: JobsBillingCard): FilterValue | undefined {
        return item.job.owner;
    }
}

@Injectable()
export class CurrentlyResponsibleFilterService extends JobUserFilterService {
    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "CurrentlyResponsible",
            label: "JobsAndBilling.AssignedRoles.CurrentlyResponsible",
        };
    }

    protected getValue(item: JobsBillingCard): FilterValue | undefined {
        return item.job.currentlyResponsible;
    }
}
